import { createRouter, createWebHistory } from 'vue-router'
import UsersView from '@/views/UsersView.vue'
import UserLoginView from '@/views/UserLoginView.vue'

import { isLoggedIn, isTokenExpired } from "@/utils/auth.js";

const routes = [
  {
    path: '/',
    name: 'Clients',
    icon: "mdi-account-group",
    description: "Manage customer contact requests.",
    component: UsersView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Sign in',
    component: UserLoginView,
    icon: 'mdi-lock',
    description: "Sign in",
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  // Capture tokens returned by the Cognito hosted UI (implicit flow) in the URL hash.
  const hash = window.location.hash.substring(1);
  if (hash) {
    const queryParams = hash.split('&');
    const tokens = {};
    for (const param of queryParams) {
      const [key, value] = param.split('=');
      tokens[key] = decodeURIComponent(value);
    }
    const idToken = tokens.id_token;
    const accessToken = tokens.access_token;
    if (accessToken) localStorage.setItem("accessToken", accessToken);
    if (idToken) localStorage.setItem("idToken", idToken);
    window.location.href = "/"
  }

  if (isTokenExpired()) {
    localStorage.clear();
    return { path: '/login' }
  }

  if (to.meta.requiresAuth && !isLoggedIn() && !isTokenExpired()) {
    return { path: '/login' }
  }
})

export default router
